import { NEXT_CONTACT_DATE_FIELDS } from "./futureFollowUpGuard.mjs";

const COMPLETED_FIELDS = ["followUpCompleted", "followupCompleted", "nextContactCompleted"];
const DONE_FIELDS = ["followUpDoneAt", "followupDoneAt"];
const PERSISTENCE_FIELDS = [
  ...NEXT_CONTACT_DATE_FIELDS, ...COMPLETED_FIELDS, ...DONE_FIELDS,
  "nextContactStatus", "followUpUpdatedAt", "manualActionAt", "manualStageUpdatedAt",
];

// Lead snapshots are deliberately whitelisted. Keep appointment evidence in
// that whitelist too: losing its timestamp lets an older Motor date win again.
export function nextContactPersistenceFields(record) {
  return Object.fromEntries(PERSISTENCE_FIELDS
    .filter(field => Object.prototype.hasOwnProperty.call(record || {}, field))
    .map(field => [field, record[field]]));
}

// An existing earlier alias or a completed flag must not outvote the new
// appointment. Persist these fields with the card, not just in the exit guard.
export function nextContactSaveChanges(record, date, updatedAt) {
  const changes = { followUp:date, followUpUpdatedAt:updatedAt };
  for (const field of NEXT_CONTACT_DATE_FIELDS) {
    if (field !== "followUp" && Object.prototype.hasOwnProperty.call(record || {}, field)) {
      changes[field] = date;
    }
  }
  for (const field of COMPLETED_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(record || {}, field)) changes[field] = false;
  }
  for (const field of DONE_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(record || {}, field)) changes[field] = null;
  }
  if (Object.prototype.hasOwnProperty.call(record || {}, "nextContactStatus")) {
    changes.nextContactStatus = "pending";
  }
  // Scheduling explicitly authorizes these date fields, even when the visible
  // value equals a Motor projection. Keep all OTHER projection fences intact.
  const metadata = record?.__commercialProjection;
  if (metadata?.fields) {
    changes.__commercialProjection = {
      ...metadata,
      fields:Object.fromEntries(Object.entries(metadata.fields)
        .filter(([field]) => !Object.prototype.hasOwnProperty.call(changes, field))),
    };
  }
  return changes;
}

export function confirmedNextContactAfterSave(record, confirmedRecord, changes) {
  // The server's confirmed identity/ownership wins, but the card write's
  // confirmed business fields win over any pre-write snapshot in the UI.
  return { ...record, ...(confirmedRecord || {}), ...changes };
}